module.exports = __webpack_public_path__ + "static/media/partners-section-logo-1.723d77c4.png";